import React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ClientModalPocketBalance from './client_modal_pocket_balance';
import ClientModalDepartures from './client_modal_departures';
import ClientModalOrders from './client_modal_orders';
import ClientModalPayments from './client_modal_payments';

const ExtraInfoOrders = (props) => {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };
  
    return (
      <div>
        <Button
          variant='contained'
          size='small'
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          Extra info
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem><ClientModalPocketBalance client={props.client} closeParent={() => handleClose()} /></MenuItem>
          <MenuItem><ClientModalDepartures client={props.client} closeParent={() => handleClose()} /></MenuItem>
          <MenuItem><ClientModalOrders client={props.client} closeParent={() => handleClose()} /></MenuItem>
          <MenuItem><ClientModalPayments client={props.client} closeParent={() => handleClose()} /></MenuItem>
        </Menu>
      </div>
    );
}
export default ExtraInfoOrders;